import { createFileRoute } from '@tanstack/react-router';
import { ReceivingListScreen } from '@/features/receiving/ReceivingListScreen';

export const Route = createFileRoute('/_app/receiving/')({
  component: ReceivingListScreen,
});
